var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnRevioAndVega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #FFFFFF;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_revio_and_vega"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.95,
    y: 37.28,
    width: 13.93,
    height: 18.03
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.29,48.2c0-2.01,1.62-3.63,3.63-3.63s3.63,1.62,3.63,3.63-1.62,3.63-3.63,3.63-3.63-1.62-3.63-3.63Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.99 52.69 44.76 52.69 44.76 11.56 23.61 11.56 23.61 36.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "43.71 8.69 47.61 8.69 47.61 12.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.76,
    y1: 42.68,
    x2: 29.41,
    y2: 42.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.61,
    y1: 27.97,
    x2: 44.76,
    y2: 27.97
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRevioAndVega);
export default __webpack_public_path__ + "static/media/icn_revio_and_vega.852a5aa49cf9c524d6c50260eeeb1706.svg";
export { ForwardRef as ReactComponent };